<div *ngIf="paymentData" class="container">
  <div class="payment-header">
    <button
      mat-button
      color="primary"
      (click)="backButton()"
      class="back-button"
    >
      <img src="/assets/images/icons/left-arrow.svg" alt="" />
    </button>
    <h1 class="page-title">Complete Purchase</h1>
  </div>
  <div class="flex-co">
    <div class="payment-section">
      <div class="box-container">
        <div class="section-header">
          <h3 class="section-title">1. Delivery Method:</h3>
        </div>
        <div class="delivery-form">
          <div class="input-label">Email:</div>
          <input
            class="delivery-input"
            placeholder="Enter Email"
            [(ngModel)]="deliveryMethod"
            id="email-input"
          />
        </div>
      </div>

      <div class="box-container fill">
        <div class="section-header">
          <h3 class="section-title">2. Payment Method:</h3>
        </div>
        <payment-methods
          [isLoggedIn]="isLoggedIn"
          [walletInsufficient]="isInsufficient"
          [remaining]="remaining"
          [gatewayGroups]="gatewayGroups"
          (walletSelected)="walletSelected($event)"
          (gatewaySelected)="onGatewayChange($event)"
        ></payment-methods>
      </div>
    </div>
    <div class="order-summary">
      <div class="login-overlay" *ngIf="!isLoggedIn">
        <div class="overlay-context">
          <p>Please Log In To Your Account To Finalize Your Order.</p>
          <button
            mat-button
            class="custom-full-button secondary"
            (click)="handleLogin()"
          >
            Login
          </button>
        </div>
      </div>
      <div class="section-header">
        <h3 class="section-title">3. Order Summary</h3>
      </div>
      <div class="item-card">
        <div class="context-co">
          <img
            class="image-card"
            defaultImage="assets/images/cards/ic_placeholder.png"
            [lazyLoad]="paymentData.product.logo"
          />
          <div class="product-info">
            <h2 class="item-title">
              {{ paymentData.product.name }}
            </h2>
            <div class="product-region">
              <span> Region: </span>
              <img
                src="{{ paymentData.country.image }}"
                alt="product region flag"
              />
              <span>{{ paymentData.country.name }}</span>
            </div>
          </div>
        </div>
        <div class="actions-co">
          <mat-select
            [(ngModel)]="paymentData.order.orderCount"
            (selectionChange)="itemCountChanged($event)"
          >
            <mat-option
              *ngFor="let item of [].constructor(10); let i = index"
              [value]="i + 1"
            >
              {{ i + 1 }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="payment-info">
        <div class="info-item">
          <div class="item-title">Price:</div>
          <div class="item-value">
            <ng-container *ngIf="paymentData.product.discount > 0">
              {{ paymentData.currency.symbol }}
              {{ paymentData.order.exchangedPrice | convertPrice }}
            </ng-container>
            <ng-container *ngIf="paymentData.product.discount <= 0">
              {{ paymentData.currency.symbol }}
              {{
                paymentData.order.exchangedPrice -
                  (paymentData.product.discount / 100) *
                    paymentData.order.exchangedPrice | convertPrice
              }}
            </ng-container>
          </div>
        </div>
        <div class="info-item">
          <div class="item-title">Quantity:</div>
          <div class="item-value">x {{ paymentData.order.orderCount }}</div>
        </div>
        <div class="info-item">
          <div class="item-title">
            Discount (<ng-container *ngIf="paymentData.product.discount > 0"
              >{{ paymentData.product.discount | convertPrice }}%</ng-container
            >
            <ng-container *ngIf="paymentData.product.discount <= 0"
              >0%</ng-container
            >):
          </div>
          <div class="item-value discount">
            <ng-container *ngIf="paymentData.product.discount > 0">
              {{ paymentData.currency.symbol
              }}{{
                (paymentData.product.discount / 100) *
                  (paymentData.order.exchangedPrice *
                    paymentData.order.orderCount) | convertPrice
              }}
            </ng-container>
            <ng-container *ngIf="paymentData.product.discount <= 0">
              {{ paymentData.currency.symbol }}0
            </ng-container>
          </div>
        </div>
        <div class="info-item">
          <div class="item-title">Total Amount:</div>
          <div class="item-value">
            {{ paymentData.currency.symbol
            }}{{
              paymentData.order.exchangedPrice * paymentData.order.orderCount -
                (paymentData.product.discount / 100) *
                  (paymentData.order.exchangedPrice *
                    paymentData.order.orderCount) | convertPrice
            }}
          </div>
        </div>

        <div class="info-item" *ngIf="processingFee">
          <div class="item-title">Processing Fee:</div>
          <div class="item-value">
            {{ processingFee | convertPrice }}{{ paymentData.currency.symbol }}
          </div>
        </div>
        <div class="info-item" *ngIf="!isInsufficient && wallet.value">
          <div class="item-title">Wallet:</div>
          <div class="item-value negative-value">
            -{{ paymentData.order.payablePrice | convertPrice
            }}{{ paymentData.currency.symbol }}
          </div>
        </div>
      </div>

      <!-- <div> -->
      <!-- <div class="subscription"> -->
      <!-- <mat-checkbox
          color="primary"
          [ngModel]="subscription"
          (change)="changeSubscription($event)"
          >Subscribe To Special Offers And News.</mat-checkbox
        > -->

      <!-- <p>
          By clicking <span class="buy-now">"BUY NOW"</span>, you confirm that you
          have read and agreed to the <a href="">Terms & Conditions</a> and
          <a href="">Privacy Policy</a>.
        </p> -->
      <!-- </div> -->
      <div class="dashed-border-container">
        <div class="item-title">Payable Amount:</div>
        <div class="item-value">
          <span>
            {{ paymentData.currency.symbol
            }}{{ paymentData.order.payablePrice | convertPrice }}
          </span>

          <span>
            {{ paymentData.currency.symbol
            }}{{ paymentData.order.payablePriceWithoutDiscount | convertPrice }}
          </span>
        </div>
      </div>
      <!-- </div> -->
      <div class="fixed-action-co">
        <ng-container *ngIf="isLoggedIn">
          <button
            mat-button
            class="custom-full-button"
            [disabled]="
              (this.gateway.invalid && this.wallet.invalid) ||
              (this.wallet.dirty && this.isInsufficient) ||
              !deliveryMethod
            "
            (click)="submitPayment()"
          >
            Buy Now
          </button>
        </ng-container>
        <ng-container *ngIf="!isLoggedIn">
          <button
            mat-button
            class="custom-full-button secondary"
            (click)="handleLogin()"
          >
            Login
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="!paymentData">
  <div class="empty-context-container">
    <div class="image-container">
      <img src="/assets/images/icons/empty-card.png" alt="empty card" />
    </div>
    <p class="empty-title">Your cart is empty !</p>
    <a mat-raised-button mat-dialog-close [routerLink]="['/']"
      >Return to home</a
    >
  </div>
</ng-container>
